import { Data } from "./types";

import { HeadCell } from "@/components/app/EnhancedTableHeader/type";

const headCells: HeadCell<Data>[] = [
    {
        id: "id",
        numeric: true,
        disablePadding: true,
        label: "ID",
    },
    {
        id: "paidAt",
        numeric: false,
        disablePadding: true,
        label: "Date/Time",
        width: 140,
    },
    {
        id: "status",
        numeric: false,
        disablePadding: true,
        label: "State",
    },
    {
        id: "planName",
        numeric: false,
        disablePadding: true,
        label: "Plan Name",
        width: 140,
    },
    {
        id: "amount",
        numeric: false,
        disablePadding: true,
        label: "Amount",
    },
    {
        id: "planPrice",
        numeric: false,
        disablePadding: true,
        label: "Plan Price",
        width: 90,
    },
    {
        id: "method",
        numeric: false,
        disablePadding: true,
        label: "Payment Method",
        width: 140,
    },
    {
        id: "paymentSource",
        numeric: false,
        disablePadding: true,
        label: "Payment Source",
        width: 130,
    },
    {
        id: "userId",
        numeric: true,
        disablePadding: true,
        label: "User ID",
        width: 80,
    },
    {
        id: "customerEmail",
        numeric: false,
        disablePadding: true,
        label: "Customer Email",
    },
    {
        id: "actions",
        numeric: false,
        disablePadding: true,
        label: "Actions",
    },
];

export default headCells;
